export default __webpack_public_path__ + "0ae010628f96c760c5f5c845a4166f62.png";